import React from 'react';
import { HeaderStripSection } from '../../components/HeaderStripSection';
import { LevelsTableSection } from '../../components/LevelsTableSection';
import { AccordionsSection } from '../../../../shared/src/components/AccordionsSection';
import { DefaultLoyaltyService } from '../../services/default-loyalty.service';

export const EditableDefaultLoyaltyContainer = () => {
    const {
        headerStripData,
        loyaltyLevels,
        loyaltyTableData,
        accordionsData,
    } = DefaultLoyaltyService.getEditableLoyaltyData();

    return <>
        <HeaderStripSection
            mainImageUrl={headerStripData.mainImage}
            backgroundImageUrl={headerStripData.backgroundImage}
            title={headerStripData.title}
            description={headerStripData.description}
            colors={headerStripData.colors}
        />
        <LevelsTableSection
            tableRows={loyaltyTableData.rows}
            tableColors={loyaltyTableData.colors}
            loyaltyLevels={loyaltyLevels}
        />
        <AccordionsSection
            title={accordionsData.title}
            items={accordionsData.items}
        />
    </>;
};
